"use client";
import React from "react";
import OnboardingContainer from "@/features/onboarding/components/OnboardingContainer";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { trpc } from "@/trpc";
import { queryClient } from "@/ajax/queryClient";
import { TRPCClientError } from "@trpc/client";
import { hasIncompleteOnboardingSteps } from "@/features/onboarding/utils/onboarding-step-rules";

export const Route = createFileRoute("/_provider/provider-onboarding/")({
  beforeLoad: async ({ context }) => {
    const [userResponse, providerUserResponse] = await Promise.allSettled([
      queryClient.fetchQuery(trpc.user.getUser.queryOptions()),
      queryClient.fetchQuery(trpc.provider.getProviderUser.queryOptions()),
    ]);

    if (userResponse.status === "rejected") {
      if (userResponse.reason instanceof TRPCClientError) {
        if (userResponse.reason.data?.code === "UNAUTHORIZED") {
          throw redirect({
            to: "/auth-provider/signin",
          });
        }
      }
    }

    // If onboarding is complete, redirect to homepage
    if (providerUserResponse.status === "fulfilled") {
      const providerUser = providerUserResponse.value;
      const isOnboardingComplete = !hasIncompleteOnboardingSteps(providerUser);
      if (isOnboardingComplete) {
        throw redirect({
          to: "/provider/home",
        });
      }
    }
  },
  component: ProviderOnboardingPage,
});

function ProviderOnboardingPage() {
  return <OnboardingContainer />;
}
